/**
 * Manage result page initialization
 *
 * @param {KmSDK} sdk
 * @param {KmSDKConfig} sdkConfig
 * @param {SearchSDK} searchSdk
 * @param {SearchBox} searchBox
 * @param {SearchBox} searchBoxMobile
 * @param {SearchBox} searchBoxMain
 */
export default function (sdk, sdkConfig, searchSdk, searchBox, searchBoxMobile, searchBoxMain) {

  // On the search result page
  const isPublicResultPage = window.location.href.indexOf('/recherche') > -1;

  let inbentaDiv = document.querySelector('#inbenta');
  if (isPublicResultPage && inbentaDiv) {
    // Add loader div
    let div = document.createElement('div');
    div.innerHTML = '<div id="loader"></div>';

    // Find the inbenta div
    inbentaDiv.appendChild(div);

    // Init 'KM' result div
    var results = sdk.component('results', '#results', {
      labels: {
        RESULTS_TEXT: `
          <img class="contents__title__picto" src="https://static-or00.inbenta.com/c26951666536b7d136620a7118c39be362b03f40edaa90c526ed66c55a1304eb/Design/PictoFaq.png">
          Dans notre centre d'aide
        `,
        RESULTS_NOT_FOUND_TEXT: 'Nous n\'avons trouvé aucun résultat pour votre recherche ',
        RESULTS_NOT_FOUND_TITLE: 'Désolé',
      },
      contents: {
        openContentOnClick: false,
        ratings: {
          labels: {
            RATINGS_INTRODUCTION: 'Avons-nous répondu à votre question ?',
            RATINGS_COMMENT_INTRODUCTION: `Nous sommes désolés de ne pas avoir répondu à votre question :-(
              <br> Vous pouvez nous aider à améliorer notre réponse en nous laissant un commentaire :`,
            RATINGS_SUBMIT_COMMENT_BUTTON: 'Envoyer',
            RATINGS_GRETTINGS_TEXT: `Merci ! Nous sommes ravis d’avoir pu vous aider. <br>
            N’hésitez pas à poser une nouvelle question ou à visiter notre site poujoulat.fr`,
          },
          elements: [
            {
              id: 1,
              label: 'Oui',
              comment: false
            },
            {
              id: 2,
              label: 'Non',
              comment: true
            }
          ],
        }
      },
    });
    // Set up result click action
    results.$on('click', content => window.open(`${sdkConfig.helpsiteURL.replace(/\/$/, '')}/content/${content.slug}/?o=gp`, '_blank'));

    // Init the two 'search' result divs
    var searchResultsProduct = searchSdk.component('results', '#resultsProduct', {
      resultsPerPage: 3,
      transformData: (result) => {
        result.title = result.title.replace('&#039;', '\'');
        result.attributes.BEST_DYNABS = result.attributes.DESCRIPTION;
        return result;
      },
      templates: {
        header: `
        <div class="inbenta-km-subtitle contents__title">
          <div class="contents__title__text">
          <img class="contents__title__picto" src="https://static-or00.inbenta.com/c26951666536b7d136620a7118c39be362b03f40edaa90c526ed66c55a1304eb/Design/PictoProduits.png">
            Dans nos produits et nos solutions
          </div>
        </div>`,
      },
      forceFilters: [
        "TYPE:Produit",
      ],
    });
    var searchResultsMag = searchSdk.component('results', '#resultsMag', {
      resultsPerPage: 3,
      transformData: (result) => {
        result.title = result.title.replace('&#039;', '\'');
        result.attributes.BEST_DYNABS = result.attributes.DESCRIPTION;
        return result;
      },
      templates: {
        header: `
          <div class="inbenta-km-subtitle contents__title">
            <div class="contents__title__text">
              <img class="contents__title__picto" src="https://static-or00.inbenta.com/c26951666536b7d136620a7118c39be362b03f40edaa90c526ed66c55a1304eb/Design/PictoChat.png">
              Dans tous nos articles
            </div>
        </div>`,
      },
      forceFilters: [
        "TYPE:Mag",
      ],
    });

    // Setup external clicks on search results
    searchResultsMag.on('click', function (content) {
      let KMSearchCode = results.getSearchCode();
      sdk.client.track('external_click', {
        externalCode: content.tracking.externalCode,
        searchCode: KMSearchCode,
      });
    });
    searchResultsProduct.on('click', function (content) {
      let KMSearchCode = results.getSearchCode();
      sdk.client.track('external_click', {
        externalCode: content.tracking.externalCode,
        searchCode: KMSearchCode,
      });
    });

    // Link KM result div to desktop menu search boxes
    if (searchBox) {
      results.linkToSearchBox(searchBox);
      // Link search result divs to floating search box
      searchBox.$on('query', function (newQuery) {
        searchResultsMag.searchStore.query = newQuery;
        searchResultsProduct.searchStore.query = newQuery;
      });
    }
    // Link KM result div to mobile menu search box
    if (searchBoxMobile) {
      results.linkToSearchBox(searchBoxMobile);
      // Link search result divs to floating search box
      searchBoxMobile.$on('query', function (newQuery) {
        searchResultsMag.searchStore.query = newQuery;
        searchResultsProduct.searchStore.query = newQuery;
      });
    }
    // Link KM result div to body search box
    if (searchBoxMain) {
      results.linkToSearchBox(searchBoxMain);
      // Link search result divs to main search box
      searchBoxMain.$on('query', function (newQuery) {
        searchResultsMag.searchStore.query = newQuery;
        searchResultsProduct.searchStore.query = newQuery;
      });
    }

    // Check URL for query string or contentID
    const queryString = new URLSearchParams(window.location.search);
    const query = queryString.get('query') || '';
    if (query !== '') {
      // Display loader
      var loader = searchSdk.component('loader', '#loader');
      searchResultsMag.linkTo(loader);
      let searchMagHasRes = false;
      let searchPrdHasRes = false;
      results.setQuery(query);
      searchResultsMag.searchStore.query = query;
      searchResultsProduct.searchStore.query = query;
      searchResultsMag.searchStore.on('result', function () {
        searchMagHasRes = searchResultsProduct.searchStore.hasResults;
      });
      searchResultsProduct.searchStore.on('result', function () {
        if (!searchResultsMag.searchStore.hasResults && !searchResultsProduct.searchStore.hasResults) {
          const noResultDiv = document.querySelector('body #inbenta .inbenta-km__results__not-found');
          const additionalText = `<div>Veuillez poser une autre question ou laissez-vous guider dans notre
            <a href="https://aide.poujoulat.fr/">centre d'aide</a>.</div>`;
          noResultDiv.insertAdjacentHTML('beforeend', additionalText);
          noResultDiv.style.display = 'block';
        }
      });
    }

    results.$on('changed', (searchData) => {
      console.log(searchData);
      setTimeout(() => {
        if(query.match(/\d{2}[-.\/ ]\d{3}[-.\/ ]\d{2}|\d{3}[-.\/ ]\d{2}/) !== null || query.match(/\d{4}\d*.?\d{1}\d*|\d{2}.\d{3}.\d{3}/) !== null) {
          let firstPhrase = document.createElement('div');
          firstPhrase.className = 'inbenta-km__results__contents__title';
          firstPhrase.innerHTML = 'Il semble que vous recherchez un produit précis, ces questions peuvent peut-être vous aider :';
          let secondPhrase = document.createElement('div');
          secondPhrase.className = 'inbenta-km__results__contents__subtitle';
          let node = null;
          if(searchData.results.length > 0) {
            node = document.querySelector('.inbenta-km__results .inbenta-km__results__extended');
          } else {
            node = document.querySelector('.inbenta-km__results .inbenta-km__results__not-found');
            document.querySelector('.inbenta-km__results__not-found').style.display = 'block';
          }

          const parentNode = node.parentNode;
          parentNode.insertBefore(firstPhrase, node);

          document.querySelector('.inbenta-km__results').appendChild(secondPhrase);

          let phrase = 'Notez que certaines informations ne sont accessibles qu\'aux professionnels dotés d\'un {{ link_1 }}<br/>Vous êtes un professionnel mais vous n\'avez pas de compte pro ? {{ link_2 }}.';

          sdk.client.getCrossSellingById(3).then((response) => {
            let attributes = response.data.results[0].attributes;
            let tracking = response.data.results[0].tracking;

            phrase = phrase.replace('{{ link_1 }}', '<a data-click="'+tracking.clickCode+'" target="_blank" href="'+attributes.URL+'">'+attributes.TEXT+'</a>');

            sdk.client.getCrossSellingById(4).then((response) => {
              let attributes = response.data.results[0].attributes;
              let tracking = response.data.results[0].tracking;

              phrase = phrase.replace('{{ link_2 }}', '<a data-click="'+tracking.clickCode+'" target="_blank" href="'+attributes.URL+'">'+attributes.TEXT+'</a>');

              secondPhrase.innerHTML = phrase;

              // Results when id product
              let crosssellingsProduct = document.querySelectorAll('.inbenta-km__results__contents__subtitle a');
              if(crosssellingsProduct.length > 0){
                for(let i = 0; i < crosssellingsProduct.length; i++) {
                  crosssellingsProduct[i].addEventListener("click", function(element) {
                    let clickCode = element.currentTarget.getAttribute('data-click');
                    sdk.client.track('click', {
                      code: clickCode
                    });
                  });
                }
              }
            });
          });


        }
      }, 500)
    });

    // Detect the case where no result returned from KM instance but search instance returned results
    const resultsDivs = document.querySelectorAll('.inbenta-search-results');
    var observer = new MutationObserver(function (mutations) {
      let disp = 0;
      const resultsDivs = document.querySelectorAll('.inbenta-search-results');
      resultsDivs.forEach((element) => {
        if (element.style.display !== 'none') {
          disp += 1;
        };
      });
      const noResultDiv = document.querySelector('body #inbenta .inbenta-km__results__not-found');
      if (disp === 0) {
        noResultDiv.style.display = 'block'
      }
    });
    resultsDivs.forEach((div) => {
      observer.observe(div, { attributes: true, attributeFilter: ['style'] });
    })
  }
}



// WEBPACK FOOTER //
// ./src/scripts/helpers/result-page.js